export function generateActions(action) {
  return {
    BEGIN: `${action}_BEGIN`,
    SUCCESS: `${action}_SUCCESS`,
    FAILURE: `${action}_FAILURE`
  };
}
